module.exports = __webpack_public_path__ + "img/2.bf6f94ac.jpg";